<div class="error-message">
  <lx-form-error-message *ngIf="withValidationErrors" ngProjectAs="additional-info"></lx-form-error-message>
</div>
<lx-section-template [sectionIndex]="sectionIndex" i18n-sectionTitle sectionTitle="Tell Us About You" data-qa="enrolment-tell-us">
  <ng-container *ngTemplateOutlet="isEnrolmentForm() ? enrollmentFormFields : freeQuoteFormFields"></ng-container>
</lx-section-template>

<ng-template #freeQuoteFormFields>
  <ng-container *ngTemplateOutlet="fullNameFields"></ng-container>

  <ng-container *ngTemplateOutlet="isPriceRequestForm() ? dateOfBirthField : null"></ng-container>

  <ng-container *ngTemplateOutlet="contactFields"></ng-container>

  <ng-container *ngTemplateOutlet="addressFields; context: { fullAddress: false }"></ng-container>

  <ng-container *ngTemplateOutlet="isPriceRequestForm() ? nationalityField : null"></ng-container>
</ng-template>

<ng-template #enrollmentFormFields>
  <ng-container *ngTemplateOutlet="fullNameFields"></ng-container>

  <ng-container *ngTemplateOutlet="addressFields; context: { fullAddress: true }"></ng-container>

  <ng-container *ngTemplateOutlet="contactFields"></ng-container>

  <ng-container *ngTemplateOutlet="dateOfBirthField"></ng-container>

  <lx-form-field
    class="form-field__single-border-input"
    label="Place of birth"
    i18n-label
    [small]="true"
    [isValid]="formData.placeOfBirth.isValid"
    [required]="formData.placeOfBirth.required"
    [errorMessage]="formData.placeOfBirth.errorMessage"
    [iconValidation]="true"
    data-qa="enrolment-place-of-birthday"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.placeOfBirth"
      [(ngModel)]="formData.placeOfBirth.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('placeOfBirth')"
      (focusout)="recalculateFormValidation('placeOfBirth')"
    />
  </lx-form-field>

  <ng-container *ngTemplateOutlet="nationalityField"></ng-container>
  <lx-form-field
    class="enrolment-form__field-mother-tongue form-field__validated-selector-padding"
    [class.form-field__no-validation]="!formData.motherTongue.value && formData.motherTongue.isValid"
    label="Mother tongue"
    i18n-label
    [small]="true"
    [isValid]="formData.motherTongue.isValid"
    [required]="formData.motherTongue.required"
    [errorMessage]="formData.motherTongue.errorMessage"
    [iconValidation]="true"
  >
    <lx-mother-tongue
      [(value)]="formData.motherTongue.value"
      (valueChange)="onValueChanges('motherTongue')"
      data-qa="enrolment-mother-language"
      lxFormDataDropdownValidity
      [formData]="formData.motherTongue"
    ></lx-mother-tongue>
  </lx-form-field>
</ng-template>

<ng-template #fullNameFields>
  <lx-form-field
    class="form-field__validated-selector-padding"
    [class.form-field__no-validation]="!formData.title.value && formData.title.isValid"
    label="Title"
    i18n-label
    [small]="true"
    [isValid]="formData.title.isValid"
    [required]="formData.title.required"
    [errorMessage]="formData.title.errorMessage"
    [iconValidation]="true"
  >
    <lx-title-selector
      [itemList]="titleOptions"
      (valueChange)="onSelectChanged('title', $event)"
      data-qa="enrolment-mother-language"
      lxFormDataDropdownValidity
      [formData]="formData.title"
    ></lx-title-selector>
  </lx-form-field>

  <lx-form-field
    label="N.I.F / N.I.E / PASAPORTE"
    i18n-label
    *ngIf="formData.identityDocument && identityDocumentFieldIsEnabled"
    [small]="true"
    [isValid]="formData.identityDocument.isValid"
    [required]="formData.identityDocument.required"
    [errorMessage]="formData.identityDocument.errorMessage"
    [iconValidation]="true"
    data-qa="qt-identity-document-field"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.identityDocument"
      [(ngModel)]="formData.identityDocument.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('identityDocument')"
      (focusout)="recalculateFormValidation('identityDocument')"
    />
  </lx-form-field>

  <lx-form-field
    class="qt-form-section__start-new-line form-field__single-border-input"
    label="First name"
    i18n-label
    [small]="true"
    [isValid]="formData.firstName.isValid"
    [required]="formData.firstName.required"
    [errorMessage]="formData.firstName.errorMessage"
    [iconValidation]="true"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.firstName"
      [(ngModel)]="formData.firstName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('firstName')"
      (focusout)="recalculateFormValidation('firstName')"
      [attr.autocomplete]="'given-name'"
      data-qa="qt-first-name-field"
    />
  </lx-form-field>

  <lx-form-field
    class="form-field__single-border-input"
    label="Last name"
    i18n-label
    [small]="true"
    [isValid]="formData.lastName.isValid"
    [required]="formData.lastName.required"
    [errorMessage]="formData.lastName.errorMessage"
    [iconValidation]="true"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.lastName"
      [(ngModel)]="formData.lastName.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('lastName')"
      (focusout)="recalculateFormValidation('lastName')"
      [attr.autocomplete]="'family-name'"
      data-qa="qt-last-name-field"
    />
  </lx-form-field>
</ng-template>

<ng-template #dateOfBirthField>
  <lx-date-of-birth-field
    i18n-label
    label="Date of birth"
    lxFormDataCustomComponentValidity
    [formData]="formData.dateOfBirth"
    [validationRequests]="validationRequests"
    #validity="lxFormDataCustomComponentValidity"
    [isValid]="(validity.enabledValidation$ | async) ? formData.dateOfBirth.isValid : null"
    [required]="formData.dateOfBirth.required"
    [errorMessage]="formData.dateOfBirth.errorMessage"
    (dateChange)="onSelectBirthDate($event)"
    data-qa="enrolment-date-birthday-date-picker"
  ></lx-date-of-birth-field>
</ng-template>

<ng-template #contactFields>
  <lx-form-field
    class="form-field__single-border-input"
    label="Email address"
    i18n-label
    [small]="true"
    [isValid]="formData.email.isValid"
    [required]="formData.email.required"
    [errorMessage]="formData.email.value | lxEmailError"
    [iconValidation]="true"
  >
    <input
      type="email"
      pInputText
      lxFormDataEmailValidity
      lxBlockSpaces
      [formData]="formData.email"
      [(ngModel)]="formData.email.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('email')"
      (focusout)="recalculateFormValidation('email')"
      [attr.autocomplete]="'email'"
      data-qa="qt-email-selector"
    />
  </lx-form-field>

  <lx-phone-number-field
    class="form-field__search-bar form-field__single-border-input"
    label="Phone number"
    i18n-label
    [isValid]="formData.phoneNumber.isValid"
    [required]="formData.phoneNumber.required"
    [validationRequests]="validationRequests"
    (valueChange)="updatePhoneNumber($event, 'phoneNumber')"
  ></lx-phone-number-field>
</ng-template>

<ng-template #addressFields let-fullAddress="fullAddress">
  <lx-form-field
    class="form-field__single-border-input"
    *ngIf="fullAddress"
    label="Address"
    i18n-label
    [small]="true"
    [isValid]="formData.address.isValid"
    [required]="formData.address.required"
    [errorMessage]="formData.address.errorMessage"
    [iconValidation]="true"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.address"
      [(ngModel)]="formData.address.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('address')"
      (focusout)="recalculateFormValidation('address')"
      [attr.autocomplete]="'address-line1'"
      data-qa="qt-address-field"
    />
  </lx-form-field>

  <lx-form-field
    class="form-field__single-border-input"
    i18n-label
    label="Postcode"
    [small]="true"
    [isValid]="formData.postcode.isValid"
    [required]="formData.postcode.required"
    [errorMessage]="formData.postcode.errorMessage"
    [iconValidation]="true"
  >
    <input
      type="text"
      pInputText
      lxFormDataPostcodeValidity
      [formData]="formData.postcode"
      [(ngModel)]="formData.postcode.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('postcode')"
      (focusout)="recalculateFormValidation('postcode')"
      [attr.autocomplete]="'postal-code'"
      data-qa="qt-post-code-field"
    />
  </lx-form-field>

  <lx-form-field
    class="form-field__single-border-input"
    label="City/Town"
    i18n-label
    [small]="true"
    [isValid]="formData.city.isValid"
    [required]="formData.city.required"
    [errorMessage]="formData.city.errorMessage"
    [iconValidation]="true"
  >
    <input
      type="text"
      pInputText
      lxFormDataInputValidity
      [formData]="formData.city"
      [(ngModel)]="formData.city.value"
      [validationRequests]="validationRequests"
      (lxNativeAutofill)="onAutoFill('city')"
      (focusout)="recalculateFormValidation('city')"
      [attr.autocomplete]="'address-level2'"
      data-qa="qt-city-field"
    />
  </lx-form-field>

  <lx-form-field
    class="form-field__validated-selector-padding form-field__no-border-dropdown"
    [class.form-field__no-validation]="!formData.countryOfResidence.value && formData.countryOfResidence.isValid"
    label="Country"
    i18n-label
    [small]="true"
    [isValid]="formData.countryOfResidence.isValid"
    [required]="formData.countryOfResidence.required"
    [errorMessage]="formData.countryOfResidence.errorMessage"
    [iconValidation]="true"
  >
    <lx-residence-country-selector
      [(value)]="formData.countryOfResidence.value"
      (valueChange)="onSelectChanged('countryOfResidence', $event)"
      data-qa="qt-country-selector"
      lxFormDataDropdownValidity
      [formData]="formData.countryOfResidence"
    ></lx-residence-country-selector>
  </lx-form-field>
</ng-template>

<ng-template #nationalityField>
  <lx-form-field
    class="form-field__validated-selector-padding"
    [class.form-field__no-validation]="!formData.nationality.value && formData.nationality.isValid"
    label="Nationality"
    i18n-label
    [small]="true"
    [isValid]="formData.nationality.isValid"
    [required]="formData.nationality.required"
    [errorMessage]="formData.nationality.errorMessage"
    [iconValidation]="true"
  >
    <lx-nationality-selector
      [(value)]="formData.nationality.value"
      (valueChange)="onValueChanges('nationality')"
      data-qa="enrolment-nationality-field"
      lxFormDataDropdownValidity
      [formData]="formData.nationality"
    ></lx-nationality-selector>
  </lx-form-field>
</ng-template>
